module.exports = __webpack_public_path__ + "img/girl-with-binoculars.0dd25522.png";